import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";

export function useForgotPassword() {
  const [openModal, setOpenModal] = useState(false);
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
  useOpenSnackbar();

  const { mutate, isLoading, data } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/auth/recover/password`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        setOpenModal(true);
      },
      onError: (error)=>{
        openSnackbar('error', error?.response?.data?.message)
      }
    }
  );
  const _submit = (data) => {
   
    mutate(data);
  };
  return {
    severity, message, openToast, setOpenToast, duration,
    openModal,
    setOpenModal,
    loading: isLoading,
    submit: _submit,
    data,
  };
}

export function useCreateNewPassword() {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/auth/forgot/password`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        setOpenModal(true);
      },
      onError: (error) => {
      
        navigate("/reset-code", {
          state: {
            email: email,
          },
        });
      },
    }
  );

  const createNewPasssword = (data) => {
 
    mutate(data);
  };

  return {
    setEmail,
    openModal,
    setOpenModal,
    loading: isLoading,
    createNewPasssword,
  };
}
